import { PlannableRowDto } from '@core/services/dtos/plannable-row.dto';
import { TaskBoardRow } from './task-board.row';

export type PlannableGrouping = 'class' | 'department' | 'project';

export class PlannableGroupingHelper {
  public static toId(group: PlannableGrouping): keyof TaskBoardRow {
    switch (group) {
      case 'project': {
        return 'projectId';
      }
      case 'department': {
        return 'departmentId';
      }
      case 'class': {
        return 'classId';
      }
    }
  }

  public static toCode(group: PlannableGrouping): keyof PlannableRowDto {
    switch (group) {
      case 'project': {
        return 'projectCode';
      }
      case 'department': {
        return 'departmentCode';
      }
      case 'class': {
        return 'classCode';
      }
    }
  }

  public static addMissingGroups(groupSelection: PlannableGrouping[]) {
    const all: PlannableGrouping[] = ['project', 'department', 'class'];
    all.forEach(group => {
      if (!groupSelection.includes(group)) {
        groupSelection.push(group);
      }
    });
    return groupSelection;
  }
}
